(function () {
  'use strict';
  var DE_MAP = {
    'Sale price': 'Verkaufspreis',
    'Regular price': 'Normaler Preis',
    'Decrease quantity': 'Menge verringern',
    'Increase quantity': 'Menge erhöhen',
    'Quantity': 'Menge'
  };
  var LB_SELECTOR = 'lb-upsell-widget, lb-upsell-long-card, [class*="lb-widget"], [class*="lb-upsell"], lb-quantity-picker';
  function isLbContext(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches(LB_SELECTOR)) return true;
    var host = node.getRootNode && node.getRootNode().host;
    if (host) return isLbContext(host);
    return !!(node.closest && node.closest(LB_SELECTOR));
  }
  function fixAriaLabels(root) {
    root.querySelectorAll('[aria-label]').forEach(function (el) {
      var lbl = el.getAttribute('aria-label');
      if (lbl && DE_MAP[lbl]) el.setAttribute('aria-label', DE_MAP[lbl]);
    });
  }
  function fixTextNodes(root) {
    var targets = root.querySelectorAll(LB_SELECTOR);
    targets.forEach(function (w) {
      var walker = document.createTreeWalker(w, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        var t = n.textContent;
        if (t && DE_MAP[t.trim()]) n.textContent = DE_MAP[t.trim()];
      }
    });
  }
  function fixNode(root) {
    root = root || document;
    fixAriaLabels(root);
    fixTextNodes(root);
  }
  var rafPending = false;
  function scheduleFix() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      fixNode(document);
    });
  }
  function init() {
    fixNode(document);
    var mo = new MutationObserver(function (muts) {
      var dirty = false;
      muts.forEach(function (m) {
        if (m.type === 'attributes') {
          if (isLbContext(m.target)) dirty = true;
          return;
        }
        if (!m.addedNodes) return;
        m.addedNodes.forEach(function (n) {
          if (isLbContext(n)) dirty = true;
        });
      });
      if (dirty) scheduleFix();
    });
    if (document.body) mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('pageshow', function () { setTimeout(scheduleFix, 0); });
})();